import { httpClient } from "@bw/shared/api";
import type {
  OrgResponse,
  PlatformFacilityListResponse,
  PlatformOrgListResponse,
} from "@bw/shared/types/generated";

export function listReservationOrganizations(
  search?: string,
  signal?: AbortSignal,
): Promise<PlatformOrgListResponse> {
  const query = new URLSearchParams({ limit: "50", offset: "0" });
  if (search?.trim()) query.set("search", search.trim());
  return httpClient.get<PlatformOrgListResponse>(
    `/platform/orgs?${query.toString()}`,
    { signal },
  );
}

export function listReservationFacilities(
  organizationId?: string,
  search?: string,
  signal?: AbortSignal,
): Promise<PlatformFacilityListResponse> {
  const query = new URLSearchParams({ limit: "100", offset: "0" });
  if (organizationId) query.set("org_id", organizationId);
  if (search?.trim()) query.set("search", search.trim());
  return httpClient.get<PlatformFacilityListResponse>(
    `/platform/facilities?${query.toString()}`,
    { signal },
  );
}

export function getReservationOrganization(
  organizationId: string,
  signal?: AbortSignal,
): Promise<OrgResponse> {
  return httpClient.get<OrgResponse>(
    `/platform/orgs/${encodeURIComponent(organizationId)}`,
    { signal },
  );
}

export function listReservationFacilitiesByIds(
  facilityIds: string[],
  signal?: AbortSignal,
): Promise<PlatformFacilityListResponse> {
  const query = new URLSearchParams({ limit: "100", offset: "0" });
  for (const facilityId of facilityIds) {
    query.append("facility_id", facilityId);
  }
  return httpClient.get<PlatformFacilityListResponse>(
    `/platform/facilities?${query.toString()}`,
    { signal },
  );
}
